export default __webpack_public_path__ + "static/media/gel-buffer-1.957ad594.svg";